import { toAdministrationMethodCode } from "../constants/administrationMethods";

/**
 * The HL7 route code a submission needs, from the administration method the record was
 * saved with.
 *
 * Lived inside the all-patient table until a second screen needed to submit as well
 * (KIN-1820).
 *
 * It used to substring-match and then default to IM, on the reasoning that every vaccine
 * is given by some route and a missing code fails the submission outright. Three things
 * were wrong with that (KIN-2115). The matching was on substrings, so any value
 * containing "im", "id", "po" or "sc" matched one of them. It could return "NASAL",
 * which is not a table 0162 code at all — 0162 has IN and NS. And the default meant an
 * unrecognised route was submitted as intramuscular, so an oral or nasal dose went to
 * NIIS as an injection: a wrong route recorded silently, which is worse than a
 * submission that fails and says so.
 *
 * The backend now resolves the route from the product before saving and stores a 0162
 * code (KIN-1679), so there is nothing left to guess at. Null when the stored value
 * resolves to nothing.
 */
export const getRouteCode = (administrationMethod) =>
  toAdministrationMethodCode(administrationMethod) || null;
